import { LinearProgress } from "@material-ui/core"
import styles from "./ReportsPage.module.scss"
import React, { FunctionComponent } from "react"

interface OperationsProgressBarProps {
    maxOperations: number
    currentOperations: number
}

export const OperationsProgressBar: FunctionComponent<OperationsProgressBarProps> = ({
    maxOperations,
    currentOperations
}) => {
    return (
        <LinearProgress
            data-testid="operations-progress-bar"
            id="operations-progress-bar"
            variant="determinate"
            className={styles.ReportsPage__usage__bar}
            value={(currentOperations / maxOperations) * 100}
        />
    )
}
